import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie-player';
import animation from './Loader.animation.json';
import './Loader.styles.scss';

export default function Loader() {
  const { t } = useTranslation('sidebar/sidebarComponent');

  return (
    <div className="Loader">
      <Lottie animationData={animation} loop play />
      <p>{t('page.modals.connection.loading')}</p>
    </div>
  );
}
